import NextImage from 'next/legacy/image'
import type React from 'react'
import type { FunctionComponent } from 'react'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import style from './Fact.module.sass'

export const Fact: FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
	const translate = useTranslate()

	return (
		<div className={style.root}>
			<div className={style.content}>
				<div className={style.title}>
					<Translation tr="fact.title" />
				</div>

				<div className={style.text}>{children}</div>
			</div>
			<div className={style.imageWrapper}>
				<NextImage
					src="/images/fact-dog-2.png"
					alt={translate('fact.alt.image')}
					title={translate('fact.alt.image')}
					layout="fill"
					objectFit="contain"
				/>
			</div>
		</div>
	)
}
